module.exports = __webpack_public_path__ + "img/time-played-by-class-p6.adefa9c0.jpg";